import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import moment from "moment";
import _ from "lodash";
import Form from "../../components/common/form";
import { getTicket, getTicketNav, saveTicket } from "../../services/ticketService";
import { saveComment, getComments } from "../../services/commentService";
import { getCustomerAccounts } from "../../services/accountService";
// import { getEmployees } from "../../services/employeeService";
import RecordNavigation from "../../components/common/recordNavigation";

class TicketForm extends Form {
  state = {
    title: "Edit Ticket",
    loadingRecord: true,
    data: {
      ticketid: "",
      subject: "",
      message: "",
      note: "",
      priority: "3",
      status: "1",
      category: "",
      assignedto: null,
      createdfor: null,
      account: "",
      createdby: null,
      duedate: "",
      alertemail: false
    },
    category: [
      { id: 1, label: "Sales", value: 1 },
      { id: 2, label: "Support", value: 2 },
      { id: 3, label: "Enquiry", value: 3 },
      { id: 4, label: "Suggestion", value: 4 }
    ],
    priority: [
      { id: 1, label: "Critical", value: 1 },
      { id: 2, label: "High", value: 2 },
      { id: 3, label: "Medium", value: 3 },
      { id: 4, label: "Low", value: 4 }
    ],
    status: [
      { id: 1, label: "New", value: 1 },
      { id: 2, label: "Assigned", value: 2 },
      { id: 3, label: "In Progress", value: 3 },
      { id: 4, label: "Pending", value: 4 },
      { id: 5, label: "Resolved", value: 5 },
      { id: 6, label: "Closed", value: 6 }
    ],
    serviceList: [],
    // employeeList: [],
    customerAccountList: [],
    showCommentBox: false,
    comment: {
      documentid: null,
      comment: null,
      createdby: null,
      source: 1
    },
    comments: [],
    errors: {},
    navPaths: [],
    filters: null,
  };

  async populateNavigationPaths() {
    try {
      const filters = this.props.location?.state?.filters;
      if (!filters) {
        const navPaths = this.props.location?.state?.nav?.paths || [];
        this.setState({ navPaths });
        return;
      }

      const params = {
        page: 1,
        pageSize: 1000,
        sortBy: filters.sortColumn?.path || 'id',
        sortOrder: filters.sortColumn?.order || 'desc',
      };

      if (filters.searchQuery) params.search = filters.searchQuery;

      const response = await getTicketNav(params);
      const tickets = response?.data?.data || [];
      const navPaths = tickets.map(t => `/tickets/${t.id}`);
      this.setState({ navPaths, filters });
    } catch (error) {
      console.error('Error fetching ticket navigation paths:', error);
      const navPaths = this.props.location?.state?.nav?.paths || [];
      this.setState({ navPaths });
    }
  }

  schema = {
    ticketid: Joi.any(),
    subject: Joi.string().max(50).required(),
    message: Joi.string().max(500).required(),
    note: Joi.any(),
    priority: Joi.string().required(),
    status: Joi.any(),
    category: Joi.number().integer().required(),
    assignedto: Joi.number().integer().allow(null),
    createdfor: Joi.any(),
    account: Joi.string().max(50).required(),
    createdby: Joi.any(),
    duedate: Joi.any(),
    alertemail: Joi.boolean()
  };

  async populateTicket() {
    try {
      this.setState({ loadingRecord: true });

      const ticketId = this.props.match.params.id;
      if (ticketId === "new") {
        const title = "New Ticket";
        const createdfor = this.props.user?.contactId || null;

        const data = { ...this.state.data, createdfor };

        this.setState({ title: title, data, loadingRecord: false });
        return;
      }

      const { data: ticket } = await getTicket(ticketId);
      const data = this.mapToViewModel(ticket);

      this.setState({ data, loadingRecord: false });
    } catch (ex) {
      this.setState({ loadingRecord: false });
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("./not-found");
    }
  }

  // async populateEmployeeList() {
  //   const { data: employees } = await getEmployees();

  //   const employeeList = employees.map(employee => {
  //     const employeelist = {};
  //     employeelist['id'] = employee.id;
  //     employeelist['label'] = employee.name;
  //     employeelist['value'] = employee.id;
  //     return employeelist;
  //   })
  //   this.setState({ employeeList });
  // }

  populateCreatedBy() {
    if (!this.state.data.id) {
      let data = { ...this.state.data };
      data['createdby'] = this.props.user.id;
      this.setState({ data });
    }
  }

  async populateComments() {
    const { data: comments } = await getComments(this.state.data.ticketid);

    const commentList = comments.map(obj => {
      const commentlist = {};
      commentlist['documentid'] = obj.documentid;
      commentlist['createdby'] = obj.author ? obj.author.fullname : 'Unknown';
      commentlist['contacttype'] = obj.author ? obj.author.contacttype : 'Unknown';
      commentlist['createdat'] = moment(obj.createdAt).calendar();
      commentlist['comment'] = obj.comment;

      return commentlist;
    })
    this.setState({ comments: commentList });
  }

  // populateDueDate () {
  //   const date = new Date();
  //   const formatted = moment(date).format("YYYY-MM-DDThh:mm").toString(); // 2024-01-02T10:48

  //   let data = {...this.state.data};
  //   data['due'] = formatted;
  //   this.setState({ data });    
  // }

  async populateCustomerAccountList() {
    try {
      const response = await getCustomerAccounts();
      const payload = response?.data;
      const accounts = Array.isArray(payload) ? payload : (payload?.data || []);
      const customerAccountList = accounts.map(account => {
        const accountlist = {};
        accountlist['id'] = account.id;
        accountlist['label'] = account.username;
        accountlist['value'] = account.username;
        return accountlist;
      })
      this.setState({ customerAccountList });
    } catch (error) {
      console.error('Error fetching customer accounts:', error);
      this.setState({ customerAccountList: [] });
    }
  }


  async componentDidMount() {
    // await this.populateEmployeeList();
    await this.populateCustomerAccountList();
    await this.populateTicket();
    !!this.state.data.ticketid && await this.populateComments();
    await this.populateNavigationPaths();
  }


  async componentDidUpdate(prevProps, prevState) {
    const prevPath = prevProps.location?.pathname;
    const nextPath = this.props.location?.pathname;

    if (prevPath !== nextPath) {
      this.setState({ loadingRecord: true });
      await this.populateTicket();
      !!this.state.data.ticketid && await this.populateComments();
      await this.populateNavigationPaths();
    }

    if (this.state.data.createdfor !== prevState.data.createdfor) {
      this.populateCustomerAccountList();
    }
  }


  mapToViewModel(ticket) {
    return {
      id: ticket.id,
      ticketid: ticket.ticketid,
      subject: ticket.subject,
      message: ticket.message,
      note: ticket.note,
      priority: ticket.priority,
      status: ticket.status,
      category: ticket.category,
      assignedto: ticket.assignedto,
      createdfor: ticket.createdfor?.id || ticket.createdfor || null,
      account: ticket.account,
      createdby: ticket.createdby,
      duedate: moment(ticket.duedate).format("YYYY-MM-DD hh:mm").toString(),
      alertemail: ticket.alertemail
    };
  }

  populateAssignedTo() {
    if (this.state.data.assignedto === "") {
      let data = { ...this.state.data };
      data.assignedto = this.props.user.id;
      this.setState({ data });
    }
  }

  doSubmit = async () => {
    try {
      let data = { ...this.state.data };
      data.createdfor = this.props.user?.contactId;
      data.createdby = this.props.user?.contactId;

      const result = await saveTicket(data);
      this.setState({ data: this.mapToViewModel(result.data) });

      if (result.data.id) {
        this.props.history.push(`/tickets/${result.data.id}`);
        this.populateTicket();
      }
      toast.success("Ticket saved successfully.");

    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        toast.error("Error: " + ex.response.data);
      }
    }
  };

  doShowCommentBox() {
    let showCommentBox = true;
    this.setState({ showCommentBox });
  }

  doSubmitComment = async (e) => {
    try {
      let comment = { ...this.state.comment };
      comment.documentid = this.state.data.ticketid;
      comment.createdby = this.props.user.id;

      // Begin: Processing Ticket Assignment
      // If customer comments on an open ticket, set the status to Pending
      let ticket = { ...this.state.data };
      if (ticket.status === 3) {
        ticket.status = 4;
      }
      ticket.alertemail = false; // Set alert email to true for ticket updates

      this.setState({ data: ticket });
      await saveTicket(ticket);
      // End: Processing Ticket Assignment

      await saveComment(comment);
      comment.comment = "";
      this.setState({ comment });
      const showCommentBox = false;
      this.setState({ showCommentBox });
      this.populateComments();
      toast.success("Comment added successfully.");
      // this.props.history.push("/tickets");
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        toast.error("Error: " + ex.response.data);
      }
    }
  };

  render() {
    return (
      <React.Fragment>
        <form className="" onSubmit={this.handleSubmit}>
          {this.renderFormButtonBar(!this.state.data.id)}

          <div className="form-input">
            <div className="d-flex justify-content-between align-items-center pt-2 pb-3">
              <h4 className="text-secondary m-0">
                {this.state.loadingRecord ? (
                  <>
                    <i className="animate-spin fa fa-spinner" /> Loading Ticket
                  </>
                ) : (
                  this.state.title
                )}
              </h4>
              <RecordNavigation
                history={this.props.history}
                currentPath={this.props.location.pathname}
                paths={this.state.navPaths || []}
              />
            </div>
            {!this.state.loadingRecord && (
              <>
                {!!this.state.data.id &&
                  <span>
                    {this.state.data.id && this.renderInput("ticketid", "Ticket ID", "", true)}
                    {this.renderSelect("status", "Status", this.state.status, true)}
                  </span>
                }
                {this.renderSelect("account", "Account", this.state.customerAccountList, !!this.state.data.id)}
                {this.renderSelect("category", "Category", this.state.category, !!this.state.data.id)}
                {this.renderSelect("priority", "Priority", this.state.priority, !!this.state.data.id)}
                {this.renderInput("subject", "Subject", "", this.state.data.id)}
                {this.renderTextArea("message", "Message")}
              </>
            )}
          </div>
        </form>

        {!!this.state.data.ticketid &&
          <span>
            <h6 className="pl-3 pt-4">Comments</h6>
            {(this.state.comments.length > 0) &&
              <div className="list-group list-group-flush small border-top">
                {this.state.comments.map(comment => (
                  <span className="list-group-item list-group-item-action">
                    <div className="d-flex w-100 justify-content-between">
                      <span className="mb-1 font-weight-bold text-secondary">{comment.createdby}</span>
                      <small className="ml-3">{comment.createdat}</small>
                    </div>
                    <div className="mb-1" style={{ whiteSpace: "pre-wrap" }}>{comment.comment}</div>
                    <div className="small d-flex align-items-left">
                      <span className={`badge badge-pill badge-${comment.contacttype === 'employee' ? 'info' : 'secondary'}`}>
                        {comment.contacttype ? comment.contacttype.charAt(0).toUpperCase() + comment.contacttype.slice(1) : 'Unknown'}
                      </span>
                    </div>
                  </span>
                ))}
              </div>
            }

            {this.state.showCommentBox &&
              <form className="p-3 border-top">
                {this.renderCommentBox("comment", "New Comment", this.state.comment.comment)}
                <button
                  className="btn btn-primary btn-sm"
                  onClick={(e) => {
                    e.preventDefault();
                    this.doSubmitComment()
                  }}
                  disabled={!this.state.comment}
                >
                  <i className="fa fa-save" /> Save
                </button>
              </form>
            }

            {!this.state.showCommentBox &&
              <div className="p-3 border-top">
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => { this.doShowCommentBox() }}
                  disabled={this.state.showCommentBox}
                >
                  <i className="fa fa-plus" /> Comment
                </button>
                <span className="ml-3 small">Add a comment.</span>

              </div>
            }
          </span>
        }


      </React.Fragment>
    );
  }
}

export default TicketForm;
